import _ from "lodash";
import React, { useCallback, useMemo } from "react";
import { CellRenderers } from "utils/tableUtils";

import GenericIntegrationTicketSystemListing from "../GenericIntegrationTicketSystemListing";
import {
  GenericIntegrationTicketDefaultValues,
  GenericIntegrationTicketSystemListingProps,
} from "../genericIntegrationTicketConstants";

function RallyIntegrationListing({
  loginConfigList,
  loading,
  ...props
}: GenericIntegrationTicketSystemListingProps) {
  const getColumns = useCallback((columns) => {
    const updatedColumns = columns.map((col: any) => {
      // Rally gets projectKey value from custom field since an earlier implementation
      if (col.dataIndex === "projectKey") {
        col.showFilter = false;
        col.showSort = false;
        col.render = (
          projectKey: string,
          record: GenericIntegrationTicketDefaultValues,
        ) => {
          const project = _.find(
            record.customFields,
            (field) => field.key === "projectValue",
          );
          return CellRenderers.VALUE_OR_NA(project?.name || projectKey);
        };
      }
      return col;
    });
    return updatedColumns;
  }, []);

  const extraColumns = useMemo(() => {
    return [
      {
        title: "Workspace",
        dataIndex: "organisation",
        render: (
          organisation: string,
          record: GenericIntegrationTicketDefaultValues,
        ) => {
          const workspace = _.find(
            record.customFields,
            (field) => field.key === "workspace",
          );
          return CellRenderers.VALUE_OR_NA(workspace?.name || organisation);
        },
        width: 130,
        ellipsis: true,
      },
    ];
  }, []);

  return (
    <div>
      <GenericIntegrationTicketSystemListing
        loginConfigList={loginConfigList}
        loading={loading}
        getColumns={getColumns}
        extraColumns={extraColumns}
        {...props}
      />
    </div>
  );
}

export default RallyIntegrationListing;
